











import { defineComponent, ref } from '@vue/composition-api';
import AppHeader from '@/components/common/AppHeader.vue';

export default defineComponent({
	name: 'App',
	components: {
		AppHeader,
	},
	setup() {
		return {
			drawer: ref(false),
		};
	},
});
